import classNames from 'clsx';
import React from 'react';

import type { GameTabsBaseColor } from '@swf/casino';
import StarsButton from '@swf/components/StarsButton/StarsButton';
import type { TrackedTranslation } from '@swf/core/types/i18n';

import styles from './ColoredButton.scss';

interface Props {
  className?: string;
  message: TrackedTranslation;
  active?: boolean;
  baseColor: GameTabsBaseColor;
  onClick?(): void;
}

const ColoredButton: React.FC<Props> = ({ active, baseColor, className, message, onClick }) => (
  <StarsButton
    className={classNames(styles.container, className, styles[baseColor], {
      [styles.active]: active
    })}
    translation={message}
    onClick={onClick}
  />
);

export default ColoredButton;
